module.exports = __webpack_public_path__ + "img/icon_social_impact.f2744f19.svg";